import React from 'react';
import styled from 'styled-components';
import { Modal } from 'modal-components';
import { Button } from 'primitive-components';
import { TaskNote } from './types';
import moment from 'moment';
import { colors } from 'bench-style-constants';

const NotesLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;
  max-height: 500px;
  overflow-y: auto;
`;
const NoteHeader = styled.div`
  color: ${colors.cloud};
`;

const TaskNotesModal = ({
  taskNotes,
  closeModal,
}: {
  taskNotes: TaskNote[];
  closeModal: () => void;
}) => {
  return (
    <Modal>
      <Modal.Header title="Notes" onClose={closeModal} />
      <Modal.Body>
        <NotesLayout>
          {taskNotes.map(note => (
            <div key={`${note.id}`}>
              <NoteHeader>
                {note.createdBy.fullName} -{' '}
                {moment(new Date(note.createdOn)).format('MMM Do YYYY, hh:mm:ss a')}
              </NoteHeader>
              <div>{note.body}</div>
            </div>
          ))}
        </NotesLayout>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={closeModal}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TaskNotesModal;
